import { registerPlugin } from "@capacitor/core";

export interface StashtMemoryPlugin {
  /** Bytes iOS will still let this process use; null where the platform has no answer. */
  availableMemory(): Promise<{ availableBytes: number | null }>;
}

const StashtMemory = registerPlugin<StashtMemoryPlugin>("StashtMemory", {
  web: {
    async availableMemory() {
      return { availableBytes: null };
    },
  },
});

export { StashtMemory };
